import { APIClient } from '@frontend/api-utils';

export class PinCodeEnumClient extends APIClient {
    public static readonly endpoint = '/pin-code-api/v1';

    public static async fetchPinCodeRenderings(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/pin-code-renderings`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchPinCodeSources(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/pin-code-sources`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchPinCodeTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/pin-code-types`);
        return await this.handleResponse<string[]>(response);
    }
}
